import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import Swal from 'sweetalert2';
import {HandleAlertsProvider} from '../../../utils/providers/handle-alerts-provider';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditSliderComponent} from '../../alerts/slider/edit-slider/edit-slider.component';

@Component({
  selector: 'app-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss']
})
export class BannerCarouselComponent implements OnInit {
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() mantenienceSection;
  @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusField: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private handleAlertsProvider: HandleAlertsProvider,
    private serviceModal: NgbModal,
  ) {
  }

  ngOnInit(): void {
  }

  deleteFromEnable(banner) {
    if (this.activeArrData.length === 1) {
      Swal.fire({
        title: 'Oops...',
        text: 'No Puedes Eliminar Todos los items en esta sección!',
        icon: 'error',
      });
    } else {
      Swal.fire({
        title: `¿Desea eliminar <b>${banner.title}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedData.emit(banner.id);
        }
      });
    }
  }

  deleteFromDisable(banner) {
    Swal.fire({
      title: `¿Desea eliminar <b>${banner.title}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletedData.emit(banner.id);
      }
    });
  }

  editSlider(banner): void {
    const modal = this.serviceModal.open(EditSliderComponent, {
      centered: true,
      windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-100pr'
    });
    modal.componentInstance.bannerInfo = banner;
    modal.result.then((res) => {
      this.editedData.emit(res);
    }, (reason) => {

    });
  }

  changeStatus(banner: any, currentStatus): any {
    this.statusField.emit({
      title: banner.title,
      id: banner.id,
      currentStatus: currentStatus === 'Desactivado'
    });
  }

}
